import { Outlet } from 'react-router-dom'
import { Box, Text, Container, Anchor } from '@mantine/core'
import { NavHeader } from '../common/NavHeader'

export function GameLayout() {
  return (
    <Box
      style={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        background: 'radial-gradient(ellipse at 50% 20%, #0d1f3c 0%, #060e1a 60%, #020408 100%)',
      }}
    >
      <NavHeader />
      <Box style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <Outlet />
      </Box>
      <Box
        component="footer"
        py="xs"
        px="lg"
        style={{
          borderTop: '1px solid rgba(0, 255, 255, 0.05)',
          background: 'rgba(6, 14, 26, 0.9)',
        }}
      >
        <Container size="lg">
          <Text size="xs" c="dimmed" ta="center">
            &copy; {new Date().getFullYear()}{' '}
            <Anchor href="https://www.bubotlearning.com" target="_blank" rel="noopener noreferrer" c="cyan.6" size="xs">
              Bubot Learning
            </Anchor>
            . All rights reserved.
          </Text>
        </Container>
      </Box>
    </Box>
  )
}
